export const classPrefix = 'react-combo-boxes-';
